<template>
  <GenericStep v-bind="$attrs">
    <div
      v-for="travel_history of peParty.travel_histories"
      :key="travel_history.id"
      class="mb-12"
    >
      <TravelHistoriesCard
        :item="travel_history"
      />
    </div>

    <SectionAdderLine
      section="Travel History"
      :has-new-section="peTravelHistoriesCardHasNewSection"
      @on-add="peTravelHistoriesCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'
import TravelHistoriesCard from '@/components/Party/PartyEdit/SectionCards/HistoryCards/TravelHistoriesCard.vue'

export default {
  name: 'TravelHistoriesStep',

  components: {
    GenericStep,
    SectionAdderLine,
    TravelHistoriesCard,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.travel_histories
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
      'peTravelHistoriesCardHasNewSection',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peTravelHistoriesCardAddSection',
    ]),
  },
}
</script>
